// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"timer_Wrapper__p2qL2","isLightMode":"timer_isLightMode__A064N"};